import {
    Box,
    Button,
    Card,
    CardContent,
    Input,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography
} from '@material-ui/core';
import {
    ClearAll,
    DeleteForeverOutlined,
    EditOutlined,
    Search
} from '@material-ui/icons';
import api from 'services/api';
import { ANAO, ASIM } from 'consts';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import { safeSetState } from 'lib/reactUtils';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { AlertInformation, DeleteConfirmationModal } from 'components';

const ESTILO_PAGINA = {
    marginLeft: 30,
    marginTop: 30,
    marginRight: 30
};

const ESTILO_CABECALHO = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    backgroundColor: '#ffffff',
    padding: '10px 16px',
    borderRadius: '8px 8px 0 0',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)'
};

const ESTILO_ADD_BUTTON = {
    height: 42,
    display: 'flex',
    alignItems: 'center',
    float: 'right',
    marginTop: 3,
    marginRight: 3
};

const ESTILO_ICONE_ACAO = {
    cursor: 'pointer',
    marginRight: 10
};

const ESTILO_TEXTO_VERMELHO = {
    color: 'red'
};

class MsgWhatsAppFornecedorList extends Component {
    state = {
        mensagens: [],
        searchFilter: {
            descricaoMensagem: '',
            situacaoInativoFilter: ANAO
        },
        openAlert: false,
        messageAlert: '',
        openDeleteMsgConfirmation: false,
        selectedMsg: null
    };

    _isMounted = false;

    safeSetState = safeSetState;

    /* Carrega os dados iniciais da tela */
    componentDidMount() {
        this._isMounted = true;
        this.loadMensagens();
    };

    /* Evita atualizar o state após sair da tela */
    componentWillUnmount() {
        this._isMounted = false;
    };

    /* Carrega as mensagens */
    loadMensagens = async () => {
        const { searchFilter } = this.state;
        const { descricaoMensagem, situacaoInativoFilter } = searchFilter;

        let active = '';
        let params = '';

        if (situacaoInativoFilter === ANAO) {
            active = '/active/true';
        } else if (situacaoInativoFilter === ASIM) {
            active = '/active/false';
        }

        // consulta pela descrição da mensagem
        if (descricaoMensagem) {
            params = `?tbmsgwhatsfornecedor.descricao=_like_${descricaoMensagem}`;
        }

        try {
            const response = await api.get(`/whatsapp/mensagemfornecedor${active}${params}`);

            this.safeSetState({ mensagens: response.data });
        } catch (error) {
            console.error('Erro ao carregar as mensagens:', error);

            this.safeSetState({ mensagens: [] });
        }
    };

    /* Deleta a mensagem */
    handleDeleteMsg = async (id) => {
        try {
            const response = await api.delete(`/whatsapp/mensagemfornecedor/${id}`);

            // verifica se a exclusão foi bem-sucedida
            if (response.status === 200) {
                this.handleCloseDeleteMsgConfirmation();
                this.loadMensagens();
            }
        } catch (error) {
            this.handleCloseDeleteMsgConfirmation();

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao excluir a mensagem!'
            );
        }
    };

    /* Confirma a exclusão */
    handleConfirmDelete = () => {
        const { selectedMsg } = this.state;

        this.handleDeleteMsg(selectedMsg);
    };

    /* Abre a janela de confirmação para a exclusão */
    handleOpenDeleteMsgConfirmation = (codmensagem) => {
        this.setState({
            openDeleteMsgConfirmation: true,
            selectedMsg: codmensagem
        });
    };

    /* Fecha a janela de confirmação da exclusão */
    handleCloseDeleteMsgConfirmation = () => {
        this.setState({ openDeleteMsgConfirmation: false });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Pesquisa os filtros na tela */
    onChangeSearch = (event) => {
        const { name, value } = event.target;

        const searchFilter = {
            ...this.state.searchFilter,
            [name]: value.toUpperCase()
        };

        this.setState({ searchFilter }, () => {
            if (name === 'situacaoInativoFilter') {
                this.loadMensagens();
            }
        });
    };

    /* Limpa os filtros da tela */
    limpaFiltros = () => {
        const searchFilter = {
            descricaoMensagem: '',
            situacaoInativoFilter: ANAO
        };

        this.setState({ searchFilter });
    };

    /* Volta para a tela de grupos de mensagem */
    onClickVoltar = () => {
        this.props.history.push('/crm/grupomsgwhatsappfornecedor');
    };

    render() {
        const {
            mensagens,
            messageAlert,
            openAlert,
            openDeleteMsgConfirmation,
            searchFilter,
            selectedMsg
        } = this.state;

        return (
            <div style={ESTILO_PAGINA}>
                <div>
                    <Box style={ESTILO_CABECALHO}>
                        <Typography
                            variant="h4"
                            style={{
                                fontWeight: 600,
                                letterSpacing: 0.5
                            }}
                        >
                            MENSAGENS WHATSAPP
                        </Typography>

                        <Box
                            style={{
                                display: 'flex',
                                gap: 10
                            }}
                        >
                            <Button
                                component={Link}
                                to="/crm/msgwhatsappfornecedor/novo"
                                variant="contained"
                                color="primary"
                                style={ESTILO_ADD_BUTTON}
                            >
                                Nova mensagem
                            </Button>
                        </Box>
                    </Box>

                    <Paper
                        style={{
                            marginBottom: 10,
                            marginTop: 10,
                            padding: 10
                        }}
                    >
                        <Box
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 5
                            }}
                        >
                            <Input
                                autoFocus
                                id="descricaoMensagem"
                                name="descricaoMensagem"
                                onChange={this.onChangeSearch}
                                placeholder="Descrição da mensagem a pesquisar"
                                style={{ width: 300 }}
                                value={searchFilter.descricaoMensagem}
                            />

                            <Select
                                id="situacaoInativoFilter"
                                name="situacaoInativoFilter"
                                value={searchFilter.situacaoInativoFilter || ''}
                                onChange={this.onChangeSearch}
                            >
                                <MenuItem value={ANAO}>
                                    Ativos
                                </MenuItem>

                                <MenuItem value={ASIM}>
                                    Inativos
                                </MenuItem>

                                <MenuItem value={'T'}>
                                    Todos
                                </MenuItem>
                            </Select>

                            <Button
                                id="pesquisar"
                                color="primary"
                                onClick={this.loadMensagens}
                            >
                                <Search />
                            </Button>

                            <Button
                                color="primary"
                                onClick={this.limpaFiltros}
                            >
                                <ClearAll />
                            </Button>
                        </Box>
                    </Paper>

                    <Card>
                        <CardContent>
                            <PerfectScrollbar>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                style={{
                                                    width: 100,
                                                    maxWidth: 100
                                                }}
                                            >
                                                Código
                                            </TableCell>

                                            <TableCell>Mensagem</TableCell>

                                            <TableCell>Ações</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {mensagens.map(mensagem => (
                                            <TableRow
                                                hover
                                                key={mensagem.idmsgwhats}
                                            >
                                                <TableCell style={(mensagem.inativo === ASIM) ? ESTILO_TEXTO_VERMELHO : {}}>
                                                    {mensagem.idmsgwhats}
                                                </TableCell>

                                                <TableCell style={(mensagem.inativo === ASIM) ? ESTILO_TEXTO_VERMELHO : {}}>
                                                    {mensagem.descricao}
                                                </TableCell>

                                                <TableCell>
                                                    <Link to={`/crm/msgwhatsappfornecedor/${mensagem.idmsgwhats}`}>
                                                        <EditOutlined style={ESTILO_ICONE_ACAO} />
                                                    </Link>

                                                    <DeleteForeverOutlined
                                                        onClick={() => this.handleOpenDeleteMsgConfirmation(mensagem.idmsgwhats)}
                                                        style={ESTILO_ICONE_ACAO}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </PerfectScrollbar>
                        </CardContent>
                    </Card>

                    <Button
                        name="voltar"
                        color="primary"
                        variant="contained"
                        onClick={this.onClickVoltar}
                        style={{ marginTop: 10 }}
                    >
                        Voltar
                    </Button>
                </div>

                <div>
                    <AlertInformation
                        open={openAlert}
                        message={messageAlert}
                        handleClose={this.handleCloseAlert}
                    />

                    <DeleteConfirmationModal
                        open={openDeleteMsgConfirmation}
                        itemId={selectedMsg}
                        message={`Confirma exclusão da mensagem ${selectedMsg}?`}
                        handleClose={this.handleCloseDeleteMsgConfirmation}
                        handleDelete={this.handleConfirmDelete}
                    />
                </div>
            </div>
        );
    }
};

export default MsgWhatsAppFornecedorList;